import React, { useState } from "react";

const SearchComponent = ({
  accountType,
  handleChange,
  handleLeadTypeChange,
  leadType,
  setFilterByObj,
  filterByObj,
}) => {

  const [error, setError] = useState("");

  const commonStyle = {
    // border: "1px solid",
    borderRadius: "5px",
    height: "40px",
    lineHeight: "1.5",
  };

  // const getCount = (value) => {
  //   if (!value) return 0;
  //   return value.split(",").filter(Boolean).length;
  // };

  //  Reusable function (keep outside component)
  const sanitizeInput = (value, isPaste = false) => {
    if (!value) return "";

    // Convert spaces/new lines/tabs → comma (only for paste OR multiple spaces)
    if (isPaste) {
      value = value.replace(/[\s\n\t]+/g, ",");
    }

    // Remove unwanted characters except comma, letters, numbers, @, .
    value = value.replace(/[^a-zA-Z0-9,@.\s]/g, "");

    // Replace multiple commas with single
    value = value.replace(/,+/g, ",");

    // Remove leading commas
    value = value.replace(/^,+/, "");

    return value;
  };




  return (
    <>
      {/* Search */}
      <div className="col-12 col-md-3">
        <label className="form-label mb-1">Search Here</label>

        <input
          type="search"
          className="form-control shadow-none"
           style={{ fontStyle: "normal" }}
          placeholder="Search by id, companyId, mob no, email"
          value={filterByObj.search || ""}
          // style={{ border: "1px solid #8E3E63", width: "300px" }}

          //  Convert SPACE → comma (only when meaningful)
          onKeyDown={(e) => {
            if (e.key === " " && e.target.value.trim() !== "") {
              e.preventDefault();

              setFilterByObj((prev) => ({
                ...prev,
                search: (prev.search || "").replace(/,+$/, "") + ",",
              }));
            }
          }}

          //  Common sanitizer
          onChange={(e) => {
            let value = e.target.value;

            value = sanitizeInput(value);

            setFilterByObj((prev) => ({
              ...prev,
              search: value,
            }));
          }}

          //  Paste handler
          onPaste={(e) => {
            e.preventDefault();

            let pastedValue = e.clipboardData.getData("text");

            pastedValue = sanitizeInput(pastedValue, true);

            setFilterByObj((prev) => {
              let existing = prev.search || "";

             
              let newValue = existing
                ? existing.replace(/,+$/, "") + "," + pastedValue
                : pastedValue;

              return {
                ...prev,
                search: newValue,
              };
            });
          }}
        />
      </div>



      {/* Account Type */}
      <div className="col-6 col-md-2">
        <label >Acc. Type</label>
        <select
          value={accountType}
          onChange={handleChange}
          className="form-select shadow-none"
          style={commonStyle}
        >
          <option value="">Select</option>
          <option value="B2B">B2B</option>
          <option value="B2C">B2C</option>
        </select>
      </div>

      {/* Lead Type */}
      <div className="col-6 col-md-2">
        <label>Lead Type</label>
        <select
          value={leadType}
          onChange={handleLeadTypeChange}
          className="form-select shadow-none"
          style={commonStyle}
        >
          <option value="">Select</option>
          <option value="Hot">Hot</option>
          <option value="Warm">Warm</option>
          <option value="Cold">Cold</option>
        </select>
      </div>
    </>
  );
};

export default SearchComponent;